const OrderDecisionEnum = {
    Approve: {id: 1, title: "დადებითი პასუხი"},
    Decline: {id: 2, title: "უარყოფითი პასუხი"},
}
export default OrderDecisionEnum